import { render, staticRenderFns } from "./ConfigWebsiteMarketRegions.vue?vue&type=template&id=ae0129ec"
import script from "./ConfigWebsiteMarketRegions.vue?vue&type=script&lang=js"
export * from "./ConfigWebsiteMarketRegions.vue?vue&type=script&lang=js"
import style0 from "./ConfigWebsiteMarketRegions.vue?vue&type=style&index=0&id=ae0129ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports